module.exports = __webpack_public_path__ + "img/59.3.TP.0b62dd12.png";